import { Auth } from "@aws-amplify/auth";
import { Col, Form, Input, message, PageHeader, Row } from "antd";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

interface FormAterarSenhaProps {}

const FormAlterarSenha: React.FC<FormAterarSenhaProps> = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [form]);

  const onFinish = async () => {
    const values = await form.validateFields();
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(
        cognitoUser,
        values.senhaAntiga,
        values.password
      );
      message.success(t("pages.MeusDados.sucesso"));
      form.resetFields();
    } catch (error: any) {
      message.error(error.message);
    }
  };

  return (
    <div>
      <PageHeader title={t("pages.MeusDados.titulo")} />
      <Form
        form={form}
        onFinish={onFinish}
        style={{ color: "#fff", marginTop: 44 }}
      >
        <Row gutter={32}>
          <Col xs={6}>
            <span className="label">{t("pages.MeusDados.senhaAntiga")}</span>
          </Col>
          <Col xs={12}>
            <Form.Item
              name="senhaAntiga"
              rules={[
                {
                  required: true,
                  message: t("pages.MeusDados.senhaAntigaObrigatoria"),
                },
              ]}
            >
              <Input.Password placeholder={t("pages.MeusDados.senhaAntiga")} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={32}>
          <Col xs={6}>
            <span className="label">{t("pages.MeusDados.senha")}</span>
          </Col>
          <Col xs={12}>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: t("pages.MeusDados.senhaObrigatoria"),
                },
              ]}
            >
              <Input.Password placeholder={t("pages.MeusDados.senha")} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={32}>
          <Col xs={6}>
            <span className="label">
              {t("pages.MeusDados.confirmacaoSenha")}
            </span>
          </Col>
          <Col xs={12}>
            <Form.Item
              name="confirm"
              dependencies={["password"]}
              rules={[
                {
                  required: true,
                  message: t("pages.MeusDados.confirmacaoSenhaObrigatoria"),
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(t("pages.MeusDados.senhaNaoCombina"))
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                placeholder={t("pages.MeusDados.confirmacaoSenha")}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={12} offset={6}>
            <button className="botao-colorido" style={{ width: "100%" }}>
              {t("pages.MeusDados.alterar")}
            </button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default FormAlterarSenha;
